import * as angular from 'angular';

import { ComponentDefinition, ContextualField, PropertyType, QualityWidgetConfiguration } from '../../../../models/index';

class QualityBadActorsContextualController implements angular.IComponentController {
    cancel: () => void;
    configuration: QualityWidgetConfiguration;
    formController: angular.IFormController;
    properties: ContextualField[];
    save: () => void;

    private _originalConfiguration: QualityWidgetConfiguration;
    static $inject = ['$q'];
    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.properties = [
            {
                modelName: 'max',
                propertyType: PropertyType.Number,
                label: 'Maximum number of items',
                placeholder: 'Maximum number of items',
                propertyName: 'maxProperty',
                required: true,
                icon: 'fa-long-arrow-up',
                extraData: {
                    min: 0,
                    max: 50,
                    decimals: 0,
                    options: {
                        debounce: 200
                    }
                },
                messages: [
                    { key: 'min', value: 'The maximum number of items must be an integer between 0 and 50' },
                    { key: 'max', value: 'The maximum number of items must be an integer between 0 and 50' },
                    { key: 'float', value: 'The maximum number of items must be an integer between 0 and 50' },
                    { key: 'required', value: 'The maximum number of items must be an integer between 0 and 50' },
                ]
            }
        ];
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtQualityBadActorsContextual: ComponentDefinition = {
    componentId: 'wtQualityBadActorsContextual',
    controller: QualityBadActorsContextualController,
    template: require('./qualityBadActorsContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        configuration: '<',
        formController: '=',
        save: '&?',
        cancel: '&?'
    }
};
